<template>
  <div class="segment__container">
    <div class="segment" v-for="step in steps" :style="getColor(step)"></div>
  </div>
</template>
<script>
export default {
  props: {
    stepNumber: {
      type: Number,
      required: true
    },
    steps: {
      type: Number,
      required: true
    }
  },
  methods: {
    getColor(step) {
      if (this.stepNumber === this.steps) {
        return `background-color: #67c7c7`;
      }
      if (step <= this.stepNumber)
        return `background-color: #881a50`;
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~StyleguideAssets/scss/master.scss";

.segment__container {
  margin-top: 6px;
}
</style>